import { ILEExamSession } from '../types';

export default (testSessions: ILEExamSession[] | undefined) =>
  testSessions
    ?.map((testSession) => ({
      ...testSession,
      id: testSession.id,
      examName: `Practice Test ${testSession.practice_test_order + 1}`,
      examType: 'Full length offline',
      examDate: `${testSession.start_date} - ${testSession.end_date}`,
    }))
    .sort((a, b) => a.practice_test_order - b.practice_test_order);
